const chevrondown = {
  name: 'chevron-down',
  viewBox: '0 0 32 32',
  paths: [
    {
      d: 'M3.749 6.125l12.251 12.251 12.251-12.251 3.749 3.749-16 16-16-16z'
    }
  ]
};

export default chevrondown;
